<template>
  <div class="v2-featured">
    <div class="section-header mb-3 mb-md-4">
      <h4 class="mb-md-1">
        {{ t("Ersties in the news!") }}
      </h4>
    </div>

    <app-carousel
      :breakpoints="{
        576: {
          itemsToShow: 2,
        },
        992: {
          itemsToShow: 3,
        },
        1281: {
          itemsToShow: 4,
        },
      }"
      theme="dark"
      @page-change="pageChange"
    >
      <slide v-for="(item, i) in featuredList" :key="i">
        <div class="featured-item" :class="getClass(i)">
          <span>{{ item.description }}</span>
          <img v-lazy="item.logo" width="200" height="40" :alt="item.description.toString().slice(0, 100)" />
        </div>
      </slide>
    </app-carousel>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Slide } from "vue3-carousel";
import AppCarousel from "@/components/v2/app-carousel/index.vue";
import { amplitudeCarouselTrack } from "@/utils/amplitude";
import { useI18n } from "vue-i18n";
import marieclaireLogo from "@/assets/v2/images/news/marieclaire.svg";
import glamourLogo from "@/assets/v2/images/news/glamour.svg";
import viceLogo from "@/assets/v2/images/news/vice.svg";
import buzzfeedLogo from "@/assets/v2/images/news/buzzfeed.svg";
import huffingtonpostLogo from "@/assets/v2/images/news/huffingtonpost.svg";
import yorkshirepostLogo from "@/assets/v2/images/news/yorkshirepost.svg";

defineOptions({
  name: "featured",
});

const { t } = useI18n();

const featuredList = ref([
  {
    logo: marieclaireLogo,
    description:
      "Ersties feels like what you would get if a porn site were also an online haven for female friendship and solidarity. The bodies are all natural, the orgasms are all real, and the site is truly a breath of fresh air.",
  },
  {
    logo: glamourLogo,
    description:
      "Ersties videos feature real women celebrating their sexuality. “No fakes, no pretenses,” the site proclaims. “This is real sex on camera.",
  },
  {
    logo: viceLogo,
    description:
      "Es gibt sie, die neue Generation der Pornografinnen. Sie sind jung, sie sind hip und sie haben eine postfeministische Vorstellung von dem, was Porno sein soll und was nicht.",
  },
  {
    logo: buzzfeedLogo,
    description:
      'They pride themselves on showcasing "real sex" with real people, as opposed to staged porn. Before every shoot, models are given a "consent talk" with the director, similar to the one shown in the TikTok.',
  },
  {
    logo: huffingtonpostLogo,
    description:
      "Keine ausgeleuchteten Körperöffnungen, keine glatt gewachsten Leiber, keine sinnlos\n" +
      "stöhnenden Frauen in akrobatischen Stellungen. Bei den Ersties wird kein Paketbote verführt.",
  },
  {
    logo: yorkshirepostLogo,
    description:
      "What I like [about Ersties] as well is that in the videos you see them putting on a condom, or you see them saying like 'No, I don't want to do that actually,” Eden added.\n" +
      '"It just feels a lot more like real life sex, you know, rather than Hollywood-esque.',
  },
  {
    logo: viceLogo,
    description:
      "Das Berliner‐Porno‐Label produziert also moderne Pornos für junge Menschen. Diese Pornos beziehen ihren Reiz aus der Authentizität. Kein Fake, kein Schein, sondern echter Sex vor der Kamera.",
  },
  {
    logo: huffingtonpostLogo,
    description:
      "Wir wollten etwas machen, das es nicht gibt”, sagen sie. Pornos aus Frauenperspektive.\n" +
      "Model geführt, die Frauen erzählen von ihren Vorlieben, von geheimen Sehnsüchten, von Lieblingspraktiken",
  },
]);

const getClass = (index: number) => {
  switch ((index + 1) % 4) {
    case 0:
      return "shadow-purple";
    case 1:
      return "shadow-light-lilac";
    case 2:
      return "shadow-pink";
    default:
      return "shadow-mint";
  }
};

const pageChange = () => {
  amplitudeCarouselTrack("Featured in slider");
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
